import template from './live-indicator.dot';
const liveIndicatorTemplate = template.default ? template.default : template;
export { liveIndicatorTemplate };
